module.exports = __webpack_public_path__ + "img/c.00dcb420.jpg";